import { notifications } from '@mantine/notifications';
import { AxiosError } from 'axios';
import { REST_API_URL } from 'env';
import isSessionAuthError from 'errors/is-session-auth-error';
import { noop } from 'lodash';

/**
 * Function to call when an unexpected error occurs.
 */
export default function panic(error: Error): void {
  const isSession401 = isSessionAuthError(error);
  const status = (error instanceof AxiosError && error.response?.status) || 0;
  const isServerError = status >= 500;
  const isHttp502 = status === 502;

  if (isSession401) {
    return; // No need to show notification, user will be logged out.
  }

  if (isServerError && !isHttp502) {
    const message = error.message || error.toString();

    notifications.show({
      title: 'Neočakávaná chyba',
      message,
      color: 'red',
      autoClose: false,
    });
  }

  fetch(`${REST_API_URL.replace(/\/$/, '')}/api/auth/log-error`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      source: 'web',
      message: JSON.stringify({
        location: window.location.href,
        session: window.localStorage.getItem('objekto.session'),
        error: {
          cause: error.cause,
          message: error.message,
          stack: error.stack,
          name: error.name,
        },
      }),
    }),
  }).catch(noop);
}
